<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div>
          <h4 class="text-center">Liquidación a cliente</h4>
          <router-link class="btn-link pull-right" to="/liquidaciones/clientes">Volver a la lista</router-link>
        </div>
      </div>
      <div class="row">
        <div class="panel">
          <div class="panel-body">
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label for="">Empresa</label>
                <combo-sucursales v-model="empresa"></combo-sucursales>
                <span class="label label-danger" v-if="!$v.empresa.required && mostrarErrores">Debe seleccionar una empresa</span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-7">
              <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Desde</label>
                    <date-picker v-model="filtros.desde"></date-picker>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Hasta</label>
                    <date-picker v-model="filtros.hasta"></date-picker>
                  </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-1">
              <div class="form-group">
                <button style="margin-top:20px" class="btn pull-right btn-fill" @click="changeCliente">
                    Aplicar
                </button>
              </div>
            </div>
          </div>
          <div class="panel-body">
              <div class="col-xs-12 col-sm-3">
                <div class="form-group">
                  <label for="">Liquidación</label>
                  <select ref="slLiquidaciones" id="" v-model="liquidacion" class="form-control select2" style="width: 100%;">
                    <option value="">Nueva liquidación</option>
                    <option v-for="liquidacion in liquidaciones" :value="liquidacion._id" :key="liquidacion._id">{{liquidacion.numero}}</option>
                  </select>
                </div>
              </div>
          </div>
          <div class="panel-footer">
            <div class="text-center center-block">
              <button class="btn btn-fill" @click="clickLiquidar">
                <template v-if="!liquidacion">Crear liquidación</template>
                <template v-else>Agregar entregas a liquidación</template>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
            <tr>
              <th>
                <button class="btn btn-fill btn-xs" @click="seleccionarTodos"><i class="fa fa-check"></i></button>
              </th>
              <th>Número</th>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Combo</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="entrega, a in entregasFiltradas">
              <tr :key="entrega._id">
                <td>
                  <div class="smart-form">
                    <label class="checkbox">
                      <input type="checkbox" :id="'selectable' + a" class="selectable" v-model="entrega.seleccionada" >
                      <i></i>
                    </label>
                  </div>
                </td>
                <td>{{entrega.numero}}</td>
                <td>{{entrega.fechaEntrega | formatFecha}}</td>
                <td>{{entrega.usuario.displayName}}</td>
                <td v-if="entrega.combo">{{entrega.combo.nombre}}</td>
                <td v-else></td>
                <td>{{entrega.montoBruto | formatMoneda}}</td>
                <td>{{entrega.estado}}</td>
                <td>
                  <button class="btn btn-link btn-xs" @click="entrega.verDetalle = !entrega.verDetalle">Ver detalle</button>
                </td>
              </tr>
              <tr v-if="entrega.verDetalle">
                <td colspan="5">
                  <table class="table table-bordered">
                    <tbody>
                      <tr v-for="plato in entrega.platos">
                        <td class="text-right">{{plato.cantidad}}x</td>
                        <td colspan="3">{{plato.plato.nombre}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from '../Shared/DatePicker'
import ComboSucursales from '../Shared/ComboEmpresasCliente'
import $ from 'jquery'
import './../../assets/css/select2.css'
import 'select2'
import moment from 'moment'
import {sortBy} from 'lodash'
import {required, minLength} from 'vuelidate/lib/validators'
import 'sweetalert2/dist/sweetalert2.css'
import swal from 'sweetalert2'
export default {
  components: {
    'combo-sucursales': ComboSucursales,
    'date-picker': DatePicker
  },
  filters: {
    formatFecha (value) {
      return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
    },
    formatMoneda (value) {
      return '$ ' + parseFloat(value).toFixed(2)
    }
  },
  validations: {
    empresa: {
      required
    },
    entregas: {
      required,
      minLength: minLength(1)
    }
  },
  data () {
    return {
      empresa: null,
      entregas: [],
      liquidacion: null,
      liquidaciones: [],
      mostrarErrores: true,
      valorCambiar: false,
      filtros: {
        desde: null,
        hasta: null
      }
    }
  },
  computed: {
    entregasFiltradas () {
      const me = this
      me.cambiarSeleccion(false)
      let entregas = me.entregas
      return sortBy(entregas, 'fechaEntrega')
    },
    entregasSeleccionadas () {
      const me = this
      return me.entregasFiltradas.filter((entrega) => {
        return entrega.seleccionada
      })
    }
  },
  methods: {
    cambiarSeleccion (valor) {
      const me = this
      me.entregas.forEach((entrega) => {
        entrega.seleccionada = valor
      })
    },
    changeCliente (e) {
      const me = this
      if (!me.empresa || me.empresa === '-1' || !me.filtros.desde || !me.filtros.hasta) {
        return []
      }
      let filters = { idEmpresa: me.empresa, desde: me.filtros.desde, hasta: me.filtros.hasta }
      me.$emit('activar-modal')
      me.$http.post('/api/admin/liquidaciones/abiertascliente', filters).then(({body}) => {
        // console.log(body)
        me.liquidaciones = body.liquidaciones
        let entregas = body.entregas
        entregas.forEach((entrega) => {
          entrega.seleccionada = false
          entrega.verDetalle = false
        })
        me.entregas = entregas
      }, (err) => {
        console.error(err)
        me.$emit('cerrar-modal')
      }).then(() => {
        me.$emit('cerrar-modal')
        $(me.$refs.slLiquidaciones).select2({
          selectOnClose: true
        }).on('change', (e) => {
          me.liquidacion = me.$refs.slLiquidaciones.value
        })
      })
    },
    clickLiquidar () {
      const me = this
      swal({
        title: 'Crear liquidación',
        text: '¿Desea crear la liquidación?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, crear',
        cancelButtonText: 'No, cerrar esta ventana'
      }).then(() => {
        me.generarLiquidacion()
      }, (dismiss) => {
        return false
      })
    },
    generarLiquidacion () {
      const me = this
      if (me.$v.$invalid) {
        me.mostrarErrores = true
        return false
      }
      me.$emit('activar-modal')
      let ids = me.entregasSeleccionadas.map((entrega) => {
        return entrega._id
      })
      me.$http.post('/api/admin/liquidaciones/cliente', {
        ids: ids,
        idEmpresa: me.empresa,
        idLiquidacion: me.liquidacion
      }).then(({body}) => {
        me.$emit('mostrar-notificacion', `La operación se ha realizado correctamente`, 'success')
        me.entregas = me.entregas.filter((entrega) => {
          return !ids.includes(entrega._id)
        })
        if (body._id) {
          me.liquidaciones.push({
            numero: body.numero,
            fechaCreacion: body.fechaCreacion,
            _id: body._id
          })
          me.liquidacion = body._id
        }
      }, (err) => {
        console.error(err)
      }).then(() => {
        me.$emit('cerrar-modal')
      })
      console.log({
        ids: ids,
        empresa: me.empresa,
        comision: me.comision,
        liquidacion: me.liquidacion
      })
    },
    seleccionarTodos () {
      console.log('seleccionarTodos')
      const me = this
      me.valorCambiar = !me.valorCambiar
      me.cambiarSeleccion(me.valorCambiar)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormCliente.vue?9b6ef542